import { useCallback } from 'react'
//
import { Wrapper } from './Styled'
import Base64Image from 'component/Base64Image'
import { useNavigateTo } from 'hooks/useNavigateTo'

import themeAssetloadingSmallLoadImageSvg from '@theme/loading/small-load-image.svg'

const loadingImage = themeAssetloadingSmallLoadImageSvg

interface StaticItemProps {
  showName?: boolean
  name?: string
  params?: any
  icon_path?: string
  placeholder?: string
  tall?: boolean
  /** 自訂點擊行為；未傳則沿用預設的 navigateToSecTagList */
  onClick?: () => void
  /** 是否關閉懶載入；預設 true 以維持既有（演员）行為 */
  noLazy?: boolean
}

export default function StaticItem({
  showName,
  name,
  params,
  icon_path,
  placeholder,
  tall = false,
  onClick,
  noLazy = true,
}: StaticItemProps) {
  const { navigateToSecTagList } = useNavigateTo()
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick()
      return
    }
    navigateToSecTagList({
      headerTitle: name as string,
      params: params ?? {},
    })
  }, [name, navigateToSecTagList, params, onClick])

  return (
    <Wrapper onClick={handleClick}>
      {/* <Image ref={imgRef} src={loadingImage} tall={tall} /> */}
      <Base64Image
        src={icon_path}
        placeholder={placeholder ?? loadingImage}
        aspectRatio={tall ? 1 / 1.7 : 1}
        noLazy={noLazy}
      ></Base64Image>
      {showName && <span>{name}</span>}
    </Wrapper>
  )
}
